import { LogoAwsColored, LogoMsAzureColored, LogoGcpColored } from "components/icons/generated";

import { CLOUD_INTEGRATIONS } from "./types";

export const GCP_INTEGRATION_DEFAULT_SCOPES = [
  "https://www.googleapis.com/auth/compute",
  "https://www.googleapis.com/auth/cloud-platform",
  "https://www.googleapis.com/auth/ndev.clouddns.readwrite",
  "https://www.googleapis.com/auth/devstorage.full_control",
  "https://www.googleapis.com/auth/userinfo.email",
];

export const CLOUD_INTEGRATION_CONFIG = {
  [CLOUD_INTEGRATIONS.AWS]: {
    type: CLOUD_INTEGRATIONS.AWS,
    name: "AWS",
    logo: LogoAwsColored,
  },
  [CLOUD_INTEGRATIONS.Azure]: {
    type: CLOUD_INTEGRATIONS.Azure,
    name: "Azure",
    logo: LogoMsAzureColored,
  },
  [CLOUD_INTEGRATIONS.GCP]: {
    type: CLOUD_INTEGRATIONS.GCP,
    name: "GCP",
    logo: LogoGcpColored,
  },
};
